import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleCallback } from "../../core/auth/auth";

const AuthCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const errorParam = params.get("error");
    const errorDescription = params.get("error_description");

    if (errorParam) {
      setError(errorDescription ?? errorParam);
      return;
    }

    if (!code) {
      setError("No se recibió el código de autorización.");
      return;
    }

    handleCallback(code)
      .then(() => navigate("/", { replace: true }))
      .catch(() => setError("No se pudo completar el inicio de sesión. Inténtalo de nuevo."));
  }, [navigate]);

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="bg-white rounded-xl shadow-sm p-10 max-w-sm w-full text-center space-y-4">
          <p className="text-sm text-error">{error}</p>
          <a href="/" className="text-sm text-secondary hover:underline">
            Volver al inicio
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white rounded-xl shadow-sm p-10 max-w-sm w-full text-center space-y-4">
        <p className="text-sm text-text-secondary">Iniciando sesión…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
